// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7f1bb7ae","732":"188dccca","977":"cd4c7523"}[chunkId] + ".chunk.js";
};